export const GET_TOKEN = 'GET_TOKEN'
export const GET_TOKEN_REFRESH = 'GET_TOKEN_REFRESH'
export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const HANDLE_SYNC_STORAGE = 'HANDLE_SYNC_STORAGE'
export const HANDLE_USER_LOGOUT = 'HANDLE_USER_LOGOUT'
export const AUTH_REQUEST = 'AUTH_REQUEST'
